import { render, staticRenderFns } from "./guoqiAi.vue?vue&type=template&id=6bc38370&scoped=true"
import script from "./guoqiAi.vue?vue&type=script&lang=js"
export * from "./guoqiAi.vue?vue&type=script&lang=js"
import style0 from "./guoqiAi.vue?vue&type=style&index=0&id=6bc38370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc38370",
  null
  
)

export default component.exports